import React from 'react';
import Modal from './Modal';
import { Button } from './Kit';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArchive } = FiIcons;

export default function ArchiveConfirmModal({ isOpen, onConfirm, onCancel, leadName, isUnarchive = false }) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
          <SafeIcon icon={FiArchive} className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1">
          <h2 className="text-base font-semibold text-gray-900">
            {isUnarchive ? 'Unarchive Lead?' : 'Archive Lead?'}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            {isUnarchive ? (
              <>
                <span className="font-medium text-gray-800">{leadName}</span> will be restored to your active leads list.
              </>
            ) : (
              <>
                Archive <span className="font-medium text-gray-800">{leadName}</span>?
                They will be hidden from your leads list.
              </>
            )}
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
        <Button variant="outline" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant={isUnarchive ? 'primary' : 'danger'} size="sm" onClick={onConfirm}>
          {isUnarchive ? 'Yes, Unarchive' : 'Yes, Archive'}
        </Button>
      </div>
    </Modal>
  );
}
